module.exports = "/_next/static/images/kiyama_curry_abocado-b62b63df6265bba2ee6087dbebd7c18d.jpg";